import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Alert, AlertType } from '../../models/alert';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor() { }
  private subject = new Subject<Alert>();
  private defaultId = 'default-alert';

  // enable subscribing to alerts observable
  onAlert(id = this.defaultId): Observable<Alert> {
    return this.subject.asObservable().pipe(filter(x => x && x.id === id));
  }

  // convenience methods
  success(message: string, options?: any, time: number=5000) {
    this.alert(new Alert({ ...options, type: AlertType.Success, message ,time:time}));
  }

  error(message: string, options?: any, time: number=5000) {
    this.alert(new Alert({ ...options, type: AlertType.Error, message,time:time }));
  }

  info(message: string, options?: any, time: number=5000) {
    this.alert(new Alert({ ...options, type: AlertType.Info, message,time:time }));
  }

  warn(message: string, options?: any, time: number=5000) {
    this.alert(new Alert({ ...options, type: AlertType.Warning, message,time:time }));
  }

  // core alert method
  alert(alert: Alert) {
    alert.id = alert.id || this.defaultId;
    alert.autoClose = (alert.autoClose === undefined ? true : alert.autoClose);
    this.subject.next(alert);
  }

  // clear alerts
  clear(id = this.defaultId) {
    this.subject.next(new Alert({ id }));
  }
}
